export const mergeData = (staticData, apiData, key = 'iso_code') => {
    return staticData.map(staticItem => {
        const apiItem = apiData.find(apiItem => apiItem[key] === staticItem[key]);
        // Merge both data objects
        //const merged = { ...staticItem, ...apiItem };
            const calOfLivability = ((Number(apiItem.private_healthcare) +
                Number(apiItem.lifestyle) +
                Number(apiItem.safety_security)) / 3);

            const calOfTotal = ((staticItem.career + staticItem.project +staticItem.employ + Number(apiItem.education) +
                Number(apiItem.economic_mobility) + calOfLivability) / 6);

            const merged = {
                ...staticItem,
                'edu': apiItem.education,
                'econ': apiItem.economic_mobility,
                'liva': Math.round(calOfLivability),
                'total': Math.round(calOfTotal),
            }
            // Calculate total if both properties exist
            // if (merged.education !== undefined && merged.rate !== undefined) {
            //     merged.total = merged.education + merged.rate;
            // }
            return merged;

    });
};